import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';

export interface CoacheesEditObserversState {
	observersId: string[];
	coacheeId: string;
}

@Injectable()
@StoreConfig({ name: 'ui-coachees-edit-observers' })
export class CoacheesEditObserversStore extends Store<CoacheesEditObserversState> {
	constructor() {
		super({});
	}
}
